<template>
  <div class="content-container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item :to="{ path: '/dashboard' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/dashboard/admin/dealers' }"
        >中间商</el-breadcrumb-item
      >
      <el-breadcrumb-item>中间商详情</el-breadcrumb-item>
    </el-breadcrumb>

    <div class="panel customer-info-panel mt-20" v-if="dealer">
      <div class="header flex-row-between">
        <span class="customer-info-title"
          >{{ dealer.name }} {{ dealer.name_en }}</span
        >
      </div>
      <div class="customer-detail">
        <dl>
          <dt>地址</dt>
          <dd>
            {{ CodeToText[dealer.province_id] }}{{ CodeToText[dealer.city_id]
            }}{{ CodeToText[dealer.county_id] }}{{ dealer.address_detail }}
          </dd>
        </dl>
        <dl>
          <dt>类别</dt>
          <dd>{{ DealerCategories[dealer.category_id] }}</dd>
        </dl>
        <dl>
          <dt>销售（服务）</dt>
          <dd>{{ dealer.user.name }}</dd>
        </dl>
        <dl>
          <dt>销售（工业）</dt>
          <dd>{{ dealer.industry_sale.name || '-' }}</dd>
        </dl>
        <dl>
          <dt>销售（科学）</dt>
          <dd>{{ dealer.science_sale.name || '-' }}</dd>
        </dl>
        <dl>
          <dt>电话销售</dt>
          <dd>{{ dealer.telesale.name || '-' }}</dd>
        </dl>
      </div>
      <div class="flex-row-between mt-20">
        <el-button
          type="primary"
          size="small"
          plain
          icon="el-icon-edit"
          @click="startDealerForm"
          v-permission="Auth.dealerEdit"
          >编辑信息</el-button
        >
        <div>
          <span :class="dealer.status == 1 ? 'text-success' : 'text-danger'">
            {{ dealer.status == 1 ? '已启用' : '已禁用' }}
          </span>
          <el-popconfirm
            v-permission="Auth.dealerStatus"
            class="ml-10"
            :title="'确认' + statusText(dealer.status) + '吗？'"
            @confirm="handleSwtichStatus()"
          >
            <el-button slot="reference" type="primary" size="small" plain>
              {{ statusText(dealer.status) }}
            </el-button>
          </el-popconfirm>
        </div>
      </div>
    </div>
    <div class="panel mt-20">
      <el-tabs v-model="activeTab">
        <el-tab-pane
          :label="'客户(' + overview.customer_count + ')'"
          name="tab1"
          v-if="hasAuth('dealerCustomer')"
        ></el-tab-pane>
        <el-tab-pane
          :label="'设备(' + overview.device_count + ')'"
          name="tab2"
          v-if="hasAuth('dealerDevice')"
        ></el-tab-pane>
        <el-tab-pane
          label="人员"
          name="tab3"
          v-if="hasAuth('dealerUser')"
        ></el-tab-pane>
        <el-tab-pane label="基本信息" name="tab5"></el-tab-pane>
        <el-tab-pane
          label="设置"
          name="tab4"
          v-if="hasAuth('dealerSetting')"
        ></el-tab-pane>
      </el-tabs>
    </div>
    <customer-list
      v-if="activeTab == 'tab1'"
      :dealerID="dealerID"
    ></customer-list>
    <customer-device-tab
      v-if="activeTab == 'tab2'"
      :dealerID="dealerID"
      :topPage="false"
    ></customer-device-tab>
    <member-tab
      ref="member"
      v-if="activeTab == 'tab3'"
      :dealerID="dealerID"
    ></member-tab>
    <set-tab v-if="activeTab == 'tab4'" :usage="dealer.usage"></set-tab>

    <template v-else-if="activeTab == 'tab5'">
      <div class="panel mt-20" v-if="dealer">
        <div class="header flex-row-between">
          <h2>基本信息</h2>
          <el-button
            type="primary"
            size="small"
            @click="startDealerForm"
            v-permission="Auth.dealerEdit"
            >编辑</el-button
          >
        </div>
        <ul class="base-info">
          <li>
            <span class="title">SAP Code：</span>
            <span>{{ dealer.sap_code }}</span>
          </li>
          <li>
            <span class="title">类别：</span>
            <span>{{ DealerCategories[dealer.category_id] }}</span>
          </li>
          <li>
            <span class="title">授权服务商：</span>
            <span>{{ dealer.is_fix_dealer == 1 ? '是' : '否' }}</span>
          </li>
          <li>
            <span class="title">销售（服务）：</span>
            <span>{{ dealer.user.name }}</span>
          </li>
          <li>
            <span class="title">级别（服务）：</span>
            <span>{{ DealerRanks[dealer.rank] }}</span>
          </li>
          <li>
            <span class="title">销售（工业）：</span>
            <span>{{ dealer.industry_sale.name }}</span>
          </li>
          <li>
            <span class="title">级别（工业）：</span>
            <span>{{ DealerRanks[dealer.rank_industry] }}</span>
          </li>
          <li>
            <span class="title">销售（科学）：</span>
            <span>{{ dealer.science_sale.name }}</span>
          </li>
          <li>
            <span class="title">级别（科学）：</span>
            <span>{{ DealerRanks[dealer.rank_science] }}</span>
          </li>
          <li>
            <span class="title">电话销售：</span>
            <span>{{ dealer.telesale.name }}</span>
          </li>
          <li>
            <span class="title">联系人：</span>
            <span>{{ dealer.contact_name }}</span>
          </li>
          <li>
            <span class="title">联系人电话：</span>
            <span>{{ dealer.contact_mobile }}</span>
          </li>
          <li>
            <span class="title">邮箱：</span>
            <span>{{ dealer.email }}</span>
          </li>
          <li>
            <span class="title">OM邮箱：</span>
            <span>{{ dealer.om_email }}</span>
          </li>
          <li>
            <span class="title">地址：</span>
            <span
              >{{ CodeToText[dealer.province_id]
              }}{{ CodeToText[dealer.city_id] }}{{ CodeToText[dealer.county_id]
              }}{{ dealer.address_detail }}</span
            >
          </li>
          <li>
            <span class="title">代理人：</span>
            <span>{{ dealer.agent_name }}</span>
          </li>
          <li>
            <span class="title">代理人电话：</span>
            <span>{{ dealer.agent_mobile }}</span>
          </li>
          <li>
            <span class="title">EC有效期：</span>
            <span>{{
              dealer.ec_deadline
                ? $time(dealer.ec_deadline).format('YYYY年M月D日')
                : ''
            }}</span>
          </li>
        </ul>
      </div>
      <div class="panel mt-20" v-permission="Auth.dealerInvoice">
        <div class="header flex-row-between">
          <h2>发票信息</h2>
          <el-button
            type="primary"
            size="small"
            @click="startDealerInvoiceFormer()"
            >编辑发票信息</el-button
          >
        </div>

        <ul class="base-info" v-if="invoice.id">
          <li>
            <span class="title">发票抬头：</span>
            <span>{{ invoice.title }}</span>
          </li>
          <li>
            <span class="title">纳税识别号：</span>
            <span>{{ invoice.tax_number }}</span>
          </li>
          <li>
            <span class="title">开户行：</span>
            <span>
              {{ invoice.bank_name }}
            </span>
          </li>
          <li>
            <span class="title">银行账号：</span>
            <span>{{ invoice.bank_account }}</span>
          </li>
          <li>
            <span class="title">地址：</span>
            <span>{{ invoice.address }}</span>
          </li>
        </ul>
      </div>
    </template>

    <dealer-former
      v-if="dealerForm"
      :model="dealerForm"
      :show.sync="dealerFormerVisible"
      @updated="updatedDealer"
    ></dealer-former>

    <invoice-former
      :model="invoiceForm"
      :show.sync="invoiceFormVisible"
      @updated="updatedInvoice"
    ></invoice-former>
  </div>
</template>

<script>
import { dealerDetail, swtichDealerStatus } from '../../service/getData'
import { CodeToText } from '@/util/area_tool'
import { DealerRanks, DealerCategories } from '@/config/global.js'
import DealerFormer from '@/components/dealer'
import CustomerList from '@/views/customer/index'
import CustomerDeviceTab from '@/views/customer_device/index'
import MemberTab from './member'
import SetTab from './set'
import { clone } from '@/util'
import auth from '../../util/auth'
import { hasAuth } from '@/permission'
import InvoiceFormer from './invoice'

export default {
  components: {
    InvoiceFormer,
    DealerFormer,
    CustomerList,
    CustomerDeviceTab,
    MemberTab,
    SetTab,
  },
  data() {
    return {
      invoiceForm: {},
      hasAuth,
      CodeToText,
      auth,
      DealerCategories,
      DealerRanks,
      dealerForm: null,
      dealerID: parseInt(this.$route.params.id),
      dealer: null,
      overview: {
        device_count: 0,
        customer_count: 0,
      },
      activeTab: 'tab1',
      dealerFormerVisible: false,
      invoice: {},
      invoiceFormVisible: false,
    }
  },
  created() {
    this.requestDealerDetail()
  },
  methods: {
    async requestDealerDetail() {
      let res = await dealerDetail(this.dealerID)
      if (res.code == 0) {
        this.dealer = res.data
        this.overview = res.data.detail_overview
        this.invoice = res.data.invoice
      }
    },
    startDealerForm() {
      this.dealerForm = clone(this.dealer)
      this.dealerForm.area = [
        this.dealerForm.province_id,
        this.dealerForm.city_id,
        this.dealerForm.county_id,
      ]
      this.dealerFormerVisible = true
    },
    updatedDealer(dealer) {
      this.dealer = dealer

      if (this.$refs.member) {
        this.$refs.member.requestMembers()
      }
    },
    async handleSwtichStatus() {
      let res = await swtichDealerStatus(this.dealer.id)
      if (res.code == 0) {
        this.dealer.status = res.data.status
        this.$message.success(`${res.data.status == 1 ? '启用' : '禁用'}成功`)

        if (this.$refs.member) {
          this.$refs.member.requestMembers()
        }
      }
    },
    statusText(status) {
      return status == 1 ? '禁用' : '启用'
    },
    startDealerInvoiceFormer() {
      this.invoiceForm = clone(this.invoice)
      this.invoiceFormVisible = true
    },
    updatedInvoice(data) {
      this.invoice = data
    },
  },
}
</script>

<style scoped>
.customer-info-panel {
  color: #6e6446;
}
.customer-info-title {
  font-size: 16px;
  color: #3e3221;
}
.customer-detail dl {
  margin: 0;
}
.customer-detail {
  display: flex;
  justify-content: space-between;
}
.customer-detail dt {
  display: block;
  color: #adb5bd;
  line-height: 1.8;
  font-size: 12px;
}
.customer-detail dd {
  display: block;
  font-size: 14px;
  line-height: 1.3;
  margin: 0;
}
.base-info {
  display: flex;
  flex-wrap: wrap;
}
.base-info li {
  width: 50%;
  padding-top: 10px;
}
.base-info .title {
  color: #999;
}
</style>